import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import './Login.css'
import * as Constants from '../../constants';
import { AuthenticationService } from '../../services/authentication.service';

const Login = (props) => {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [emailError, setEmailError] = useState('')
	const [passwordError, setPasswordError] = useState('')

	const navigate = useNavigate();

	const [t, i18n] = useTranslation("global");

	const authenticationService = new AuthenticationService();
	
	const toastErrorLogin = () => toast.error(t('app.error.login.fail'));
	const toastUnauthorizedLogin = () => toast.error(t('app.error.login.sinPermiso'));
	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {
		const authentication = authenticationService.getAuthenticationSession();
		

		if (authentication !== null) {
			navigate(Constants.ROUTE_ESTABLECIMIENTOS);
		}

		const userBrowserLang = getUserBrowserLanguage();

		i18n.changeLanguage(userBrowserLang);
	}, [i18n]);

	const getUserBrowserLanguage = () => {
		const lang = window.navigator.language;

		if (lang.includes("es")) return "es";
		if (lang.includes("ca")) return "ca";
		if (lang.includes("en")) return "en";

		return "en";
	};

	const onButtonClick = (e) => {
		e.preventDefault();

		// Set initial error values to empty  
		setEmailError('')
		setPasswordError('')

		// Check if the user has entered both fields correctly  	
		if ('' === email) {
			setEmailError(t('app.error.login.email'))
			return
		}

		if (!checkEmailFormat(email)) {
			setEmailError(t('app.error.login.emailFormat'))
			return
		}

		if ('' === password) {
			setPasswordError(t('app.error.login.password'))
			return
		}

		login(email, password);
	}

	const login = async (email, password) => {
		const toastLoading = toast.loading(t('app.mensaje.loading'));

		await AuthenticationService.oauthToken(email, password)
			.then((response) => {

				if (response.status === 200) {
					toast.dismiss(toastLoading);

					return response.json();
				} else {
					if (response.status === 401) {
						toast.dismiss(toastLoading);

						toastErrorLogin();
					} else {
						toast.dismiss(toastLoading);

						toastGenericErrorLogin();
					}
				}
			})
			.then((data) => {
				if (data != null) {

					authenticationService.handleAuthenticationData(data, i18n);

					if (authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_TRABAJADOR 
							&& authenticationService.getAuthenticationSession().user.tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) {
						navigate(Constants.ROUTE_PERSONAL);
					}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_TRABAJADOR 
							&& authenticationService.getAuthenticationSession().user.tipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO) {
						navigate(Constants.ROUTE_CAMAS);
					}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_TRABAJADOR 
							&& authenticationService.getAuthenticationSession().user.tipoEmpleado.id === Constants.TIPO_EMPLEADO_RECEPCION) {
						navigate(Constants.ROUTE_HABITACIONES);
					}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_TRABAJADOR 
							&& authenticationService.getAuthenticationSession().user.tipoEmpleado.id === Constants.TIPO_EMPLEADO_CAMARERO) {
						toastUnauthorizedLogin();
						
						authenticationService.setAuthenticationSession(null);
					}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_TRABAJADOR 
							&& authenticationService.getAuthenticationSession().user.tipoEmpleado.id === Constants.TIPO_EMPLEADO_GERENTE) {
						toastUnauthorizedLogin();
						
						authenticationService.setAuthenticationSession(null);
					}else {
						navigate(Constants.ROUTE_ESTABLECIMIENTOS);
					}
				}
			})
			.catch((err) => {
				toast.dismiss(toastLoading);

				toastGenericErrorLogin();
			});
	}

	function checkEmailFormat(email) {
		const isValidEmail = Constants.emailRegex;

		if (isValidEmail.test(email)) {
			return true;
		} else {
			return false;
		}
	}

	return (
		<div className="login-container">
			<div className="login-image">
				<img src={require("../../assets/img/portada.png")} alt="Login Image" />
			</div>
			<div className="login-form">
				<div className="login-logo">
					<img src={require("../../assets/img/logo.png")} alt="Login Logo" />
				</div>
				<form onSubmit={onButtonClick}>
					<div className={'inputContainerLogin'}>
						<input
							value={email}
							placeholder={t('app.login.email')}
							onChange={(ev) => setEmail(ev.target.value)}
							className={'inputBox'}
						/>
						<label className="errorLabel">{emailError}</label>
					</div>
					<br />
					<div className={'inputContainerLogin'}>
						<input
							type='password'
							value={password}
							placeholder={t("app.login.password")}
							onChange={(ev) => setPassword(ev.target.value)}
							className={'inputBox'}
						/>
						<label className="errorLabel">{passwordError}</label>
					</div>
					<br />
					<div className={'inputContainerLogin'}>
						<input className={'inputButtonLogin'} type="submit" value={t("app.login.conectar")} />
						<Toaster />
					</div>
					<div className={'linkContainer'}>
						<a href={Constants.ROUTE_RESET_PASSWORD} className={'link'}>{t('app.login.olvidoContraseña')}</a>
					</div>
				</form>
			</div>
		</div>
	)
}

export default Login